import { useMemo } from 'react';
import { orDash } from '../../../../utils/schema-parse';
import type { ResumoCard, ResumoIndicador } from './resumo-view.types';

interface ResumoOcorrenciasGridProps {
  cards: ResumoCard[];
}

const IndicadorValor = ({ indicador }: { indicador: ResumoIndicador }) => {
  const valores = indicador.valores ?? [];

  if (valores.length === 0) return <span>-</span>;

  return (
    <span className="rv-resumo-oc-chips">
      {valores.map((item, indice) => (
        <span
          // eslint-disable-next-line react/no-array-index-key
          key={`${indice}-${item.valor}`}
          className="rv-resumo-oc-chip"
          style={{
            color: item.cor ? item.cor : undefined,
            fontWeight: item.bold ? 600 : 400,
          }}
        >
          {item.cor ? (
            <span
              className="rv-resumo-oc-dot"
              style={{ background: item.cor }}
            />
          ) : null}
          {orDash(item.valor)}
        </span>
      ))}
    </span>
  );
};

const COLUNAS_GRID = 2;

const porOrdem = (a: ResumoIndicador, b: ResumoIndicador) =>
  (a.ordem ?? 0) - (b.ordem ?? 0);

const spanDoCard = (indice: number, total: number) => {
  const resto = total % COLUNAS_GRID;

  if (resto !== 1) return undefined;

  return indice === total - 1 ? '1 / -1' : undefined;
};

const ResumoOcorrenciasGrid = ({ cards }: ResumoOcorrenciasGridProps) => {
  const ordenados = useMemo(
    () => [...cards].sort((a, b) => a.ordem - b.ordem),
    [cards],
  );

  if (ordenados.length === 0) return null;

  return (
    <div
      className="rv-resumo-oc-grid"
      style={{ '--rv-oc-cols': COLUNAS_GRID } as React.CSSProperties}
    >
      {ordenados.map((card, indice) => (
        <div
          key={card.chave}
          className="rv-resumo-oc-card"
          style={{ gridColumn: spanDoCard(indice, ordenados.length) }}
        >
          <div className="rv-resumo-oc-card-title">{card.titulo}</div>

          <div className="rv-resumo-oc-body">
            {[...card.indicadores].sort(porOrdem).map((indicador, linha) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={`${indicador.ordem}-${linha}-${indicador.label}`}
                className="rv-resumo-oc-field"
              >
                <span className="rv-resumo-oc-field-label">
                  {orDash(indicador.label)}
                </span>
                <span className="rv-resumo-oc-field-value">
                  <IndicadorValor indicador={indicador} />
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResumoOcorrenciasGrid;
